import { api } from '@Services/config';

const getProducts = async (url) =>
  api.get(`Equipment/GetUserEquipments/${url}`);

const getUnregisteredProducts = async (url) =>
  api.get(`Equipment/GetUnregisteredEquipment/${url}`);

const getProduct = async (url) =>
  api.get(`Equipment/GetEquipment/${url}`).then((res) => res.data);

const getMultiProducts = async (url) =>
  api.get(`Equipment/GetMultipleEquipment/${url}`).then((res) => res.data);

const getMultiAllRegProducts = async (url) =>
  api.get(`Equipment/GetAllRegisteredEquipment/${url}`);

const getMultiAllUnRegProducts = async (url) =>
  api.get(`Equipment/GetAllUnregisteredEquipment/${url}`);

// const getProduct = async (equipmentNumber, isLandingPage) => {
//   console.warn(isLandingPage, 'isLandingPage');
//   const url = isLandingPage
//     ? `Equipment/GetEquipment/${equipmentNumber}?isLandingPage=${isLandingPage}`
//     : `Equipment/GetEquipment/${equipmentNumber}`;
//   return api.get(url).then((res) => res.data);
// };
const getProductStatus = async (equipmentNumber) =>
  api
    .get(`Equipment/GetEquipmentStatus/${equipmentNumber}`)
    .then((res) => res.data);

const getMultiProductStatus = async (url) =>
  api
    .get(`Equipment/GetMultipleEquipmentStatus/${url}`)
    .then((res) => res.data);

const requestForTransfer = async (payload = {}) => {
  const url = `Equipment/SendTransferEquipmentMail`;
  return api.post(url, payload);
};

const dashBoardService = {
  getProductStatus,
  getMultiProductStatus,
  getProducts,
  getUnregisteredProducts,
  getProduct,
  requestForTransfer,
  getMultiProducts,
  getMultiAllRegProducts,
  getMultiAllUnRegProducts,
};

export default dashBoardService;
